import user from "./user";
import tabsView from "./tabs-view";
import register from "./register";
import notice from "./notice";
import holidays from "./holidays";
import theme from "./theme";
export default {
  user,
  tabsView,
  register,
  notice,
  holidays,
  theme
};
